import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'

import Marker from './Marker'
import Cluster from './Cluster'
import Loader from './Loader'
import Tile from './Tile'

const MapComponent = {
  Marker: withErrorBoundary(Marker),
  Cluster: withErrorBoundary(Cluster),
  Loader: withErrorBoundary(Loader),
  Tile: withErrorBoundary(Tile),
} as const

export default MapComponent
